export default {
  MODULE_NAME: 'users',
};
